import { LowerCasePipe, TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SubscriptionSummaryDto } from '@workspace/data-types';
import {
  AvatarAuraComponent,
  BaseDataTableCoreComponent,
  DataTableComponent,
  LuxonDatePipe,
} from '@workspace/ng-aura';
import { PriceDisplayPipe, SubscriptionStatusDisplayPipe } from '@workspace/ng-data-access';
import { SubscriptionColumnKey } from './abstract-subscriptions-data-table.component';
import { SubscriptionsDataTableFilterCoreComponent } from './filter/subscriptions-data-table-filter.component';

@Component({
  selector: 'core-subscriptions-data-table',
  templateUrl: './subscriptions-data-table.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatButtonModule,
    MatCellDef,
    MatCell,
    LuxonDatePipe,
    TitleCasePipe,
    LowerCasePipe,
    SubscriptionStatusDisplayPipe,
    PriceDisplayPipe,
    MatIconModule,
    MatTooltipModule,
    SubscriptionsDataTableFilterCoreComponent,
    AvatarAuraComponent,
    RouterModule,
  ],
})
export class SubscriptionsDataTableCoreComponent extends BaseDataTableCoreComponent<
  SubscriptionSummaryDto,
  SubscriptionColumnKey
> {}
